<div class="container">
  <div class="payment-container w-depth">
    <div class="details-box">
      <div class="order-details w-depth">
        <div class="detail-row">
          <div class="detail-icon">
            <i class="wahii-icon-can-2"></i>
          </div>
          <div class="detail-text">
            <span>
              {{order?.specs?.recipient?.type}}
              <span *ngIf="order?.specs?.recipient?.feet">{{order?.specs?.recipient?.feet}} ft</span>
              <br>
            </span>
            <div *ngIf="order?.specs?.recipient?.name">{{order?.specs?.recipient?.name}}</div>
            <div *ngIf="order?.specs?.recipient?.location">{{order?.specs?.recipient?.location}}</div>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-icon">
            <i class="wahii-icon-jerrycan"></i>
          </div>
          <div class="detail-text">
            <div>{{order?.specs?.product?.name}}</div>
            <div>{{order?.specs?.product?.amount}} {{'GALLONS' | translate}}</div>
            <div>{{order?.specs?.recipient?.fillUp}}</div>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-icon">
            <i class="wahii-icon-calendar2-outline"></i>
          </div>
          <div class="detail-text">
            <div>{{order?.deliveryDate}}</div>
            <span *ngIf="selectedHours.length == 3">
              {{'TIME.ANYTIME' | translate}}
            </span>
            <span *ngIf="selectedHours.length < 3">
              <span *ngIf="selectedHours.indexOf('morning')!=-1">
                {{'TIME.MORNING' | translate}}
                <span *ngIf="selectedHours.length == 2"> and </span>
              </span>
              <span *ngIf="selectedHours.indexOf('afternoon')!=-1">
                {{'TIME.AFTERNOON' | translate}}
                <span
                  *ngIf="selectedHours.length == 2 && selectedHours.indexOf('morning') == -1"> and </span>
              </span>
              <span *ngIf="selectedHours.indexOf('evening')!=-1">
                {{'TIME.EVENING' | translate}}
              </span>
            </span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-icon">
            <i class="wahii-icon-marker2-outline"></i>
          </div>
          <div class="detail-text">{{address}}</div>
        </div>
        <div class="detail-row">
          <div class="detail-icon">
            <i class="wahii-icon-info-2-outline"></i>
          </div>
          <div class="detail-text">{{order?.comments}}</div>
        </div>
        <div class="detail-row promo-detail" *ngFor="let discount of discounts">
          <div class="detail-promo"></div>
          <div class="detail-amount promo-amount">
            {{order?.total + discount.discount | currency: 'USD':'symbol':'1.2-2'}}
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-total">
            {{'REQUEST.PAYMENT.TOTAL' | translate}}
          </div>
          <div class="detail-amount">
            {{order?.total | currency}} *
          </div>
        </div>
        <div class="detail-row promo-text" *ngIf="discounts?.length">
          <div *ngIf="isGiveaway">
              {{'REQUEST.PAYMENT.GIVEAWAY' | translate}} {{totalDiscount | currency: 'USD': 'symbol': '1.2-2'}}
          </div>
          <div *ngIf="!isGiveaway">
              {{'REQUEST.PAYMENT.PROMOTEXT' | translate}} {{totalDiscount | currency: 'USD': 'symbol': '1.2-2'}}
          </div>
        </div>
      </div>
      <div class="payment" [ngClass]="{signUp: !isLoggedIn}">
        <div class="card-box w-depth" *ngIf="selectedCard">
          <div class="card-icon">
            <img [src]="'./assets/svg/'+selectedCard?.brand_short+'.svg'">
          </div>
          <div class="card-data">*{{selectedCard.last4}} - {{selectedCard.getExpiration()}}</div>
          <div class="card-change" (click)="openPaymentDialog()">{{'REQUEST.PAYMENT.CHANGE' | translate}}</div>
        </div>

        <div class="card-box w-depth" *ngIf="!discounts?.length && isLoggedIn">
          <div class = "checkoutCode">
              <input class="codeInput" [placeholder]="'PROMOS.ENTER' | translate" #input
                    (input)="promoCodeClaim=$event.target.value.toUpperCase()" [(ngModel)]="promoCodeClaim">
              <button class="codeButton orange-btn btn-wave" (click)="claimPromo(promoCodeClaim)"
                      [disabled]="!promoCodeClaim">
                Claim
              </button>
          </div>
        </div>
          <div class="add-payment-box w-depth" *ngIf="!selectedCard && !showLoader && isLoggedIn">
            <button class="w-btn blue-btn btn-wave payment-btn" (click)="openPaymentDialog()">
              {{'REQUEST.PAYMENT.ADDPAYMENT' | translate}}
            </button>
          </div>
        
        <div class="confirm-payment">
          <div class="text">* {{'REQUEST.PAYMENT.ESTIMATE' | translate}}</div>
          <div *ngIf="isLoggedIn">
            <button class="w-btn submit-btn btn-wave" (click)="openConfirmDialog()" [disabled]="!selectedCard">
              {{'REQUEST.PAYMENT.CONFIRMBTN' | translate}}
            </button>
          </div>
          <div *ngIf="!isLoggedIn && !showLoader">
            <button class="w-btn submit-btn btn-wave" (click)="signUp()">
              {{'SIGNUP' | translate}}
            </button>
          </div>
        </div>
        <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
      </div>
    </div>
  </div>
</div>
